'use client'

// React Imports
import { useEffect } from 'react'

// Component Imports
import { Button } from '@/components/ui/button'

// Util Imports
import { isStaleDeploymentError, reloadIfStale } from '@/lib/stale-deployment'

// Style Imports
import './globals.css'

const GlobalError = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
  useEffect(() => {
    console.error(error)

    /* ! Бүрхүүл өөрөө унасан ч зөрүү бол ачаалж эдгэнэ ([[stale-deployment]]). */
    reloadIfStale(error)
  }, [error])

  const stale = isStaleDeploymentError(error)

  /*
   * ! `lang='en'` ЗӨВ — энэ хуудасны бичвэр бүхэлдээ англи (доор). `global-error` нь root layout-ийг
   * ! орлодог client component тул `cookies()` уншиж, dictionary татаж чадахгүй (bundle-д бүх толь орно);
   * ! `lang`-ийг бичвэрийн хэлтэй таарч байлгах нь WCAG 3.1.1. Бичвэрийг орчуулах бол `lang`-ийг хамт солино.
   */

  return (
    <html lang='en' className='flex min-h-full w-full antialiased'>
      <body className='flex min-h-full w-full flex-auto flex-col'>
        <main className='flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-center'>
          <div className='space-y-1.5'>
            <h1 className='text-xl font-semibold tracking-tight'>Something went wrong</h1>
            <p className='text-muted-foreground mx-auto max-w-sm text-sm text-pretty'>
              An unexpected error stopped this page from rendering. Try again - if it keeps happening, the digest below
              identifies the failure in the server logs.
            </p>
          </div>

          {error.digest ? <p className='text-muted-foreground font-mono text-xs'>Digest: {error.digest}</p> : null}

          <Button onClick={() => (stale ? window.location.reload() : reset())}>Try again</Button>
        </main>
      </body>
    </html>
  )
}

export default GlobalError
